import React from 'react'
import PropType from 'prop-types'
import { Panel } from 'react-bootstrap'

const MigrationKeyPanel = (props) => {
	const { eventKey, activeFAQKey } = props

	const downloadPlugin = () => {
		let manualDownloadUrl = `/migration/download_plugin?plugin_name=${PLUGNAMES.MIGRATEGURU}`
		window.open(manualDownloadUrl, '_self')
	}

	return (<Panel eventKey={eventKey}>
		<Panel.Heading bsClass="panel-heading">
			<Panel.Title toggle>
				<p className="bv-faq-que">
					{ activeFAQKey == eventKey ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
									What is MigrateGuru Migration Key?
				</p>
			</Panel.Title>
		</Panel.Heading>
		<Panel.Body collapsible>
			<div className="bv-faq-ans">
								MigrateGuru Migration key is a unique identifier that is used to authenticate and authorize the migration process between two websites.
								To generate a migration key, you will need to install the Migrate Guru plugin on the destination site,
								which is the site that you want to migrate your data to.
				<ol className="mt-1" style={{listStyle: 'auto'}}>
					<li>Go to the destination site</li>
					<li><u className='pointer-on-hover text-info font-600' onClick={downloadPlugin}>Download</u> and Install Migrate Guru plugin. >=<em>v4.85</em></li>
					<li>On the Migrate Guru plugin page, click "Migration Key?"</li>
					<li>Migration Key will be generated and displayed</li>
					<li>Copy Migration Key and paste it into the migration form</li>
					<li>Fill in any other required details, such as HTTP auth credentials or server IP etc., and click "Migrate."</li>
				</ol>
			</div>
		</Panel.Body>
	</Panel>)
}

MigrationKeyPanel.propTypes = {
	eventKey: PropType.string,
	activeFAQKey: PropType.string
}

export default MigrationKeyPanel
